import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import {
  ConnectionChangeType,
  InterpretingSessionType,
} from 'features/call/call-base/enums';
import { sendConnectionCallState } from 'features/call/call-base/store';
import { callIdSelector } from 'features/call/call-base/store/selectors';
import { handleError } from 'features/notification/store';
import { ReturnToQueueDaoService } from 'features/return-to-queue/services';
import type { ReturnToQueuePayload } from 'features/return-to-queue/store';
import { userIdSelector } from 'features/user/store';

export const returnToQueue = createAsyncThunk(
  'returnToQueue',
  async (
    payload: ReturnToQueuePayload,
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const state = getState() as RootState;
      const callId = callIdSelector(state);
      const userId = userIdSelector(state);

      const { holdServerIp } = await ReturnToQueueDaoService.returnToQueue({
        callId,
        userId,
        ...payload,
      });

      dispatch(
        sendConnectionCallState({
          connectionChangeType: ConnectionChangeType.RETURN_TO_QUEUE_DISCONNECT,
          interpretingSessionType: InterpretingSessionType.NORMAL,
        })
      );

      return holdServerIp;
    } catch (error) {
      dispatch(handleError({ error }));
      return rejectWithValue(error);
    }
  }
);
